import classNames from 'classnames'

interface DotsProps {
  dotsQuantity: number
  currentSlide: number
  onMoveToSlide: (index: number) => void
}

export const Dots = ({
  dotsQuantity,
  currentSlide,
  onMoveToSlide
}: DotsProps) => {
  return (
    <div className="flex w-full items-center justify-center gap-2">
      {[...Array(dotsQuantity).keys()].map(idx => (
        <button
          key={idx}
          aria-label={`Página ${idx + 1} do carrossel`}
          onClick={() => onMoveToSlide(idx)}
          className={classNames('rounded-full border border-orange-light', {
            'h-3 w-3 bg-orange-light': currentSlide === idx,
            'h-2 w-2': currentSlide !== idx
          })}
        />
      ))}
    </div>
  )
}
